<template>
  <a-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item label="公司名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-select
                  v-decorator="['devUserId', validatorRules.devUserId]"
                  placeholder="请选择公司名称"
                  @select="changeCompanyName"
                >
                  <a-select-option v-for="d in companyData" :key="d.id">
                    {{ d.companyName }}
                  </a-select-option>
                </a-select>
        </a-form-item>
        <a-form-item label="模板编号" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['tempCode', {initialValue:tempCode}]" disabled></a-input>
        </a-form-item>
        <a-form-item label="模板名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['tempName', validatorRules.tempName]" placeholder="请输入模板名称"></a-input>
        </a-form-item>
        <!-- <a-form-item label="内容" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['content', validatorRules.content]" placeholder="请输入内容"></a-input>
        </a-form-item> -->
        <!-- <a-form-item label="参数个数" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number
            v-decorator="['paramsNum', validatorRules.paramsNum]"
            placeholder="请输入参数个数"
            style="width: 100%"
          />
        </a-form-item> -->
        <a-form-item label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['remark', validatorRules.remark]" placeholder="请输入备注"></a-input>
        </a-form-item>
        <a-form-item label="是否启用" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag
            type="list"
            v-decorator="['izState', {initialValue:'1'}]"
            :trigger-change="true"
            dictCode="user_status"
            placeholder="请选择是否启用"
          />
        </a-form-item>
        <a-form-item label="消息模板" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-list size="small" bordered :data-source="this.msgTagList">
            <a-list-item slot="renderItem" slot-scope="item, index">
              <a-space>
                <a-button type="primary" icon="arrow-up" @click="upMsgTemplate(index)"></a-button>
                <a-button type="primary" icon="arrow-down" @click="downMsgTemplate(index)"></a-button>
              </a-space>
              <span style="width: 300px">{{ item }}</span>
              <a-space>
                <a-button type="primary" icon="edit" @click="modifyMsgTemplate(index)"></a-button>
                <a-popconfirm title="确定删除吗?" @confirm="() => delMsgTemplate(index)">
                  <a-button type="dashed" icon="close"></a-button>
                </a-popconfirm>
              </a-space>
            </a-list-item>
          </a-list>
          <a-button type="primary" icon="plus" @click="openMsgTemplate" :visible="true"> 添加消息模板 </a-button>
          <add-modal
            ref="addModal"
            :visible="true"
            @msgValue="msgValue(arguments)"
            :modifyMsgValue="modifyMsgValue"
          ></add-modal>
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import { httpAction,getAction } from '@/api/manage'
import pick from 'lodash.pick'
import { validateDuplicateValue } from '@/utils/util'
import AddModal from './AddModal'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import Vue from 'vue'

export default {
  name: 'BusGisWechatDeveloperMsgTempModal',
  components: {
    AddModal,
  },
  data() {
    return {
      form: this.$form.createForm(this),
      title: '操作',
      width: 800,
      visible: false,
      model: {},
      //公司名称数组
      companyData:[],
      //公司名称
      devUserName:'',
      //模板编号
      tempCode:'',
      //接收消息文本框
      msgTagValue: '',
      //接收消息数组
      msgTagList: [],
      //发送给后端的消息模板
      msgContent: '',
      //判断单选类型参数
      radioValue: '',
      //发送给子组件的内容
      modifyMsgValue: '',
      //需要修改的数组的索引
      indexNum: 0,
      //参数个数
      parameterNum: 0,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      validatorRules: {
        devUserId: { rules: [] },
        devUserName: { rules: [] },
        tempName: { rules: [] },
        content: { rules: [] },
        paramsNum: { rules: [] },
        remark: { rules: [] },
        tempCode:{rules:[]},
        izState: { rules: [{ required: true, message: '请选择是否启用' }] },
      },
      url: {
        add: '/wechat.base/busGisWechatDeveloperMsgTemp/add',
        edit: '/wechat.base/busGisWechatDeveloperMsgTemp/edit',
        company:'/wechat.base/busGisWechatDeveloperMsgTemp/findDevAccounts',
        mseTempCode:'/wechat.base/busGisWechatDeveloperMsgTemp/getMseTempCode'
      },
    }
  },
  created() {},
  methods: {
    add() {
      this.edit({})
    },
    edit(record) {
      this.companyShow()
      this.tempCodeShow()
      this.msgTagList = record.msgTagList && JSON.parse(record.msgTagList)
      this.parameterNum = 0
      this.form.resetFields()
      this.model = Object.assign({}, record)
      this.visible = true
      this.$nextTick(() => {
        this.form.setFieldsValue(
          pick(this.model, 'devUserId', 'devUserName','izState','tempCode', 'tempName', 'content', 'paramsNum', 'remark')
        )
      })
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    changeCompanyName(val){
      this.companyData.forEach((item) =>{
        if(item.id == val){
          this.devUserName = item.companyName
        }
      })
    },
    //获取公司名称
    companyShow(){
      getAction(this.url.company).then((res) => {
        if(res.success){
          this.companyData =  res.result
        }
      })
    },
    //获取模板编码
    tempCodeShow(){
       getAction(this.url.mseTempCode).then((res) => {
        if(res.success){
            this.tempCode = res.result
        }
      })   
    },

    //子组件回传的文本框值
    msgValue(val) {
      //判断单选类型
      this.radioValue = val[1]
      //文本框内容
      this.msgTagValue = val[0]
      if(this.msgTagList == undefined){
        this.msgTagList = [];
      }
      console.log(val)
      if (val[2] == true) {
        this.msgTagList.splice(this.indexNum, 1, this.msgTagValue)
      } else {
        console.log(this.msgTagList,'xxxxxxxx')
        this.msgTagList.push(this.msgTagValue)
      }
    },
    handleOk() {
      Vue.ls.set('msgTagList', this.msgTagList, 7 * 24 * 60 * 60 * 1000)
      this.msgTagList.forEach((item, index) => {
        if (item == '{参数}') {
          this.parameterNum += 1
          this.msgTagList[index] = '{' + this.parameterNum + '}'
        }
      })
      this.msgContent = ''
      this.msgTagList.forEach((item) => {
        this.msgContent += item
      })
      console.log(this.msgContent) //内容
      //触发表单验证
      const that = this
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true
          let httpurl = ''
          let method = ''
          if (!this.model.id) {
            httpurl += this.url.add
            method = 'post'
          } else {
            httpurl += this.url.edit
            method = 'post'
          }

          let formData = Object.assign(this.model, values)
          formData.content = this.msgContent
          formData.paramsNum = this.parameterNum
          formData.msgTagList = JSON.stringify(Vue.ls.get('msgTagList'))
          console.log(this.devUserName)
          formData.devUserName = this.devUserName
          console.log('表单提交数据', formData)
          httpAction(httpurl, formData, method)
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message)
                that.$emit('ok')
              } else {
                that.$message.warning(res.message)
              }
            })
            .finally(() => {
              that.confirmLoading = false
              that.close()
            })
        }
      })
    },
    handleCancel() {
      this.close()
    },
    //消息模板删除
    delMsgTemplate(index) {
      this.msgTagList.splice(index, 1)
    },
    //修改消息模板
    modifyMsgTemplate(index) {
      this.indexNum = index
      if (this.msgTagList[index] == '{参数}') {
        this.$message.error('参数不可编辑')
      } else {
        this.modifyMsgValue = this.msgTagList[index]
        this.$refs.addModal.show()
      }
    },
    //向上
    upMsgTemplate(index) {
      console.log(index)
      if (index <= 0) {
        this.$message.error('已经是第一个了')
      } else {
        this.msgTagList.splice(index - 1, 0, this.msgTagList.splice(index, 1)[0])
      }
    },
    //向下
    downMsgTemplate(index) {
      if (index == this.msgTagList.length - 1) {
        this.$message.error('已经是最后一个了')
      } else {
        this.msgTagList.splice(index + 1, 0, this.msgTagList.splice(index, 1)[0])
      }
    },
    //增加模板
    openMsgTemplate() {
      this.modifyMsgValue = ''
      this.$refs.addModal.add()
    },
    popupCallback(row) {
      this.form.setFieldsValue(pick(row, 'devUserId', 'devUserName', 'tempName', 'content', 'paramsNum', 'remark'))
    },
  },
}
</script>
<style lang="less" scoped>
.tagStyle {
  font-size: 14px;
  margin-top: 1%;
  font-weight: 300;
  height: 34px;
  line-height: 34px;
  display: noset;
  color: rgb(255, 255, 255);
  background-color: rgb(10, 150, 243);
}
</style>